import { useState } from 'react';
import type { DailyInsightResult } from '@vitalai/ai-core';
import { Card } from './Card';
import { fetchDailyInsight } from '../services/apiClient';
import { useDataSourceMode } from '../services/useDataSourceMode';

export function DailyInsightCard() {
  const [mode] = useDataSourceMode();
  const [insight, setInsight] = useState<DailyInsightResult | null>(null);
  const [cached, setCached] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (mode !== 'cloudflare') {
    return (
      <Card title="Insight del dia (IA)">
        <p className="hint-text">Elegi "Cloudflare (D1)" en Perfil para generar un resumen diario con IA (DeepSeek).</p>
      </Card>
    );
  }

  const handleGenerate = async (force: boolean) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetchDailyInsight(force);
      setInsight(response.insight);
      setCached(response.cached);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card title="Insight del dia (IA)" subtitle="Generado con DeepSeek a partir de tus datos reales">
      {!insight ? (
        <button type="button" className="primary-button" onClick={() => handleGenerate(false)} disabled={isLoading}>
          {isLoading ? 'Generando…' : 'Generar insight del dia'}
        </button>
      ) : (
        <div className="daily-insight">
          <p className="daily-insight__summary">{insight.summary}</p>
          <p>
            <strong>Sueno:</strong> {insight.sleepInsight}
          </p>
          <p>
            <strong>Recuperacion:</strong> {insight.recoveryInsight}
          </p>
          <p>
            <strong>Actividad:</strong> {insight.activityInsight}
          </p>
          <p>
            <strong>Nutricion:</strong> {insight.nutritionInsight}
          </p>
          <p className="daily-insight__recommendation">{insight.recommendation}</p>
          {cached ? <p className="hint-text">Ya generado hoy; "Regenerar" pide una version nueva al modelo.</p> : null}
          <button type="button" onClick={() => handleGenerate(true)} disabled={isLoading}>
            {isLoading ? 'Regenerando…' : 'Regenerar'}
          </button>
        </div>
      )}
      {error ? <p className="debug-error">{error}</p> : null}
      <p className="disclaimer">VitalAI no realiza diagnosticos medicos. Este resumen describe asociaciones en tus propios datos.</p>
    </Card>
  );
}
